import React from 'react';
import { Link } from 'react-router-dom';
import { SoftwareIqFooter } from '@softwareiq/brand-ui';
import darkLogo from '@softwareiq/brand-ui/assets/logo-dark.png';
import { marketingBaseUrl, researchBaseUrl } from '../../config/siteUrls';

function Footer() {
  return (
    <SoftwareIqFooter
      documentationLink={<Link to="/documentation">Documentation</Link>}
      marketingBaseUrl={marketingBaseUrl}
      researchBaseUrl={researchBaseUrl}
      logoSrc={darkLogo}
    />
  );
}

export default Footer;
